import type { RouterConfig } from '@nuxt/schema'
import type { RouteRecordRaw } from 'vue-router'

// 👉 Redirects
const redirects: RouteRecordRaw[] = [
  // ℹ️ The index page (pages/index.vue) is now the default landing page
  // No redirect needed - Nuxt will automatically use pages/index.vue for '/'
]

// 👉 Custom routes
const routes: RouteRecordRaw[] = []

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
  routes: scannedRoutes => [
    ...redirects,
    ...routes,
    ...scannedRoutes,
  ],
  scrollBehaviorType: 'smooth',
  scrollBehavior(to) {
    if (to.hash) {
      // Check if element exists before trying to scroll to it
      if (typeof document !== 'undefined' && document.querySelector(to.hash)) {
        return { el: to.hash, behavior: 'smooth', top: 60 }
      }

      // Element doesn't exist, scroll to top instead
      return { top: 0 }
    }

    return { top: 0 }
  },
}
